export default "__VITE_ASSET__7b71aeb9__"